import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxVoucher from '../util/remote/ajaxVoucher';

const initialState = { 
    customerKPIs: {
      total: 2,
      active24h: 0,
      newToday: 0
    },
    KPIsLoaded: false,
    customers: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const CustomerContext = createContext();

export const CustomerProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({ q: '', from: '', to: '' });

  useEffect(()=>{
      if(state.mounted){
        getCustomers(false, true);
      }
    }, [state.currentPage, state.mounted])

  const getCustomerKPIs = async (refresh = false) => {
    if(!refresh && state.KPIsLoaded) return;
    if(refresh){
        dispatch({ type: 'customerKPIs', payload: initialState.customerKPIs });
        dispatch({ type: 'KPIsLoaded', payload: false });
    }
    const server_response  = await ajaxVoucher.fetchCustomerKPIs({filters});
    if(server_response.status === "OK"){
        dispatch({ type: 'customerKPIs', payload: server_response.details });
        dispatch({ type: 'KPIsLoaded', payload: true });
    }
  };

  const getCustomers = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.customers) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'customers', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxVoucher.fetchCustomers({ page: refresh ? 1 : state.currentPage, filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'customers', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'customers', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

   const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };


  return(
    <CustomerContext.Provider value={{
      ...state,
      filters,
      setFilters,
      dispatch,
      getCustomerKPIs,
      getCustomers,
      setCurrentPage ,
      setMounted
      }}>
      {children}
    </CustomerContext.Provider>
  )

}

export const useCustomer = ()=>useContext(CustomerContext);

